/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupPolicyPlan } from '../models/BackupPolicyPlan';
import { BackupPolicyResourceSelector } from '../models/BackupPolicyResourceSelector';
import { ScheduleMode } from '../models/ScheduleMode';

export class UpdateBackupPolicyRequest {
  /**
  * Backup policy display name.
  */
  'name': string;
  /**
  * Whether the policy is enabled.
  */
  'enabled'?: boolean;
  'resourceSelector': BackupPolicyResourceSelector;
  'backupPlan': BackupPolicyPlan;
  'scheduleMode'?: ScheduleMode;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "resourceSelector",
      "baseName": "resourceSelector",
      "type": "BackupPolicyResourceSelector",
      "format": ""
    },
    {
      "name": "backupPlan",
      "baseName": "backupPlan",
      "type": "BackupPolicyPlan",
      "format": ""
    },
    {
      "name": "scheduleMode",
      "baseName": "scheduleMode",
      "type": "ScheduleMode",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateBackupPolicyRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



